import { checkZone, formatDistanceM } from '@conversia/shared-types';

/**
 * Línea "cerró a X m del objetivo" del panel /jobs (Bloque 1 ubicación del
 * técnico). PURO. `enZona`: true/false con geocerca evaluable; null = solo
 * hay coordenadas del cierre (sin objetivo — se muestran sin juicio).
 */
export function closureZoneLabel(job: {
  closedLat?: number | null;
  closedLng?: number | null;
  targetLat?: number | null;
  targetLng?: number | null;
  geofenceRadiusM?: number | null;
}): { text: string; enZona: boolean | null } | null {
  if (job.closedLat == null || job.closedLng == null) return null;

  const zone = checkZone(
    { lat: job.closedLat, lng: job.closedLng },
    job.targetLat != null && job.targetLng != null
      ? { lat: job.targetLat, lng: job.targetLng }
      : null,
    job.geofenceRadiusM ?? null,
  );
  if (zone) {
    return {
      text: `Cerró a ${formatDistanceM(zone.distanceM)} del objetivo`,
      enZona: zone.enZona,
    };
  }
  return {
    text: `Cerró en (${job.closedLat.toFixed(5)}, ${job.closedLng.toFixed(5)})`,
    enZona: null,
  };
}
